// extracted by mini-css-extract-plugin
export var actionText = "_pi-4";
export var container = "_pi-0";
export var leftSection = "_pi-1";
export var rightSection = "_pi-2";
export var settingsButton = "_pi-6";
export var settingsIcon = "_pi-7";
export var shortcut = "_pi-5";
export var shortcutGroup = "_pi-3";